import { render, staticRenderFns } from "./DeclarationInfoConfirm.vue?vue&type=template&id=bb0f8a2c&scoped=true"
import script from "./DeclarationInfoConfirm.vue?vue&type=script&lang=ts"
export * from "./DeclarationInfoConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0f8a2c",
  null
  
)

export default component.exports